<form #form="ngForm" (ngSubmit)="submit()" novalidate>
  <div class="modal-header">
    <h5 class="modal-title">{{ itemToSave?.id ? "Modification " + title : "Enregistrement " + title }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
  </div>

  <div class="modal-body">
  <div class="row g-3">
    <div class="col-md-3">
      <label class="form-label">Nom</label>
      <input type="text" class="form-control" name="nom" [(ngModel)]="itemToSave.nom" required #nomCtrl="ngModel">
      <div class="text-danger" *ngIf="nomCtrl.invalid && nomCtrl.touched">Nom est requis</div>
    </div>

    <div class="col-md-3">
      <label class="form-label">Prénom</label>
      <input type="text" class="form-control" name="prenom" [(ngModel)]="itemToSave.prenom" #prenomCtrl="ngModel">
      <div class="text-danger" *ngIf="prenomCtrl.invalid && prenomCtrl.touched">Prénom est requis</div>
    </div>

    <div class="col-md-3">
      <label class="form-label">Téléphone</label>
      <input type="text" class="form-control" name="telephone" [(ngModel)]="itemToSave.telephone" required
        #telephoneCtrl="ngModel">
      <div class="text-danger" *ngIf="telephoneCtrl.invalid && telephoneCtrl.touched">Téléphone est requis</div>
    </div>

    <div class="col-md-3">
      <label class="form-label">Email</label>
      <input type="email" class="form-control" name="email" [(ngModel)]="itemToSave.email" #emailCtrl="ngModel">
    </div>

    <div class="col-md-3">
      <label class="form-label">Genre</label>
      <select class="form-select" name="genre_id" [(ngModel)]="itemToSave.genre_id" #genre="ngModel">
        <option value="" disabled selected>-- Sélectionner --</option>
        <option *ngFor="let item of itemsGenre" [value]="item.id">{{ item.libelle }}</option>
      </select>
      <div class="text-danger" *ngIf="genre.invalid && genre.touched">Genre est requis</div>
    </div>

    <div class="col-md-3">
      <label class="form-label">Civilité</label>
      <select class="form-select" name="civilite_id" [(ngModel)]="itemToSave.civilite_id" #civilite="ngModel">
        <option value="" disabled selected>-- Sélectionner --</option>
        <option *ngFor="let item of itemsCivilite" [value]="item.id">{{ item.libelle }}</option>
      </select>
      <div class="text-danger" *ngIf="civilite.invalid && civilite.touched">Civilité est requise</div>
    </div>

    <div class="col-md-3">
      <label class="form-label">Nature de pièce</label>
      <select class="form-select" name="nature_piece_id" [(ngModel)]="itemToSave.nature_piece_id"
        #nature_piece="ngModel">
        <option value="" disabled selected>-- Sélectionner --</option>
        <option *ngFor="let item of itemsNaturePiece" [value]="item.id">{{ item.libelle }}</option>
      </select>
      <div class="text-danger" *ngIf="nature_piece.invalid && nature_piece.touched">Nature pièce est requise</div>
    </div>

    <div class="col-md-3">
      <label class="form-label">Numéro pièce</label>
      <input type="text" class="form-control" name="numero_piece" [(ngModel)]="itemToSave.numero_piece"
        #numero_pieceCtrl="ngModel">
    </div>

    <div class="col-md-3">
      <label class="form-label">Date de naissance</label>
      <input type="text" class="form-control" name="date_naissance" [(ngModel)]="itemToSave.date_naissance"
        #date_naissanceCtrl="ngModel" bsDatepicker [maxDate]="maxBirthDate" placeholder="dd/mm/yyyy" required />
      <div class="text-danger" *ngIf="date_naissanceCtrl.errors?.['required'] && date_naissanceCtrl.touched">
        Date de naissance est requise
      </div>
      <div class="text-danger"
        *ngIf="itemToSave.date_naissance && !isAtLeast18(itemToSave.date_naissance)">
        Le client doit avoir au moins 18 ans
      </div>
    </div>

    <div class="col-md-3">
      <div class="mb-2">
        <img [src]="imageDisplay || 'assets/images/default/default.avif'" class="img-fluid rounded"
          style="height:100px; object-fit:cover;">
      </div>
      <input hidden id="img" type="file" accept=".png, .jpg, .jpeg, .bmp" (change)="uploadFile($event)" name="photo" />
      <label for="img" class="btn btn-primary w-100 text-white py-2" style="cursor: pointer;">
        Choisir une image
      </label>
    </div>
  </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="dismiss()">Fermer</button>
    <button type="submit" class="btn btn-primary"
      [disabled]="form.invalid || !isAtLeast18(itemToSave.date_naissance) || isLoading"
      (click)="confirmSaveItem(itemToSave)">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
      Sauvegarder
    </button>
  </div>
</form>
